/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
class Core {
	constructor() {
		if (!siteId || !apiUrl) throw new Error("Missing required global vars.");
		this.siteId = siteId;
		this.apiUrl = apiUrl;
		this.minimumOrderValue = 25;
		this.freeDeliveryThreshold = 50;
		this.minDeliveryCost = 4.9; // we might want to check calendar API for the smaller delivery fee

		window.cart = window.cart || {};
		window.cart.cartId = Core.getCookie("patch_cartId");
		window.cart.cartSize = Core.getCookie("patch_cartQty") || 0;

		window.patch = {
			siteId: this.siteId,
			addItemsCart: this.addItemsCart.bind(this),
			updateItemsCart: this.updateItemsCart.bind(this),
			addDiscountCode: this.addDiscountCode.bind(this),
			removeItemsCart: this.removeItemsCart.bind(this),
		};

		this.messages = new Messages();
		this.modalContainer = document.getElementById("modalContainer");
		this.cartBagIcons = document.querySelectorAll(`[data-cart-icon]`);
		this.cartQuantityIcon = document.querySelector(`[data-cart-quantity]`);

		this.btnAddToCart = document.querySelectorAll("[data-add-to-cart]");
	}

	addToCartSource(elTarget) {
		const getPageType = () => {
			const pageTypes = {
				pages: "page",
				products: "product",
				collections: "category",
			};
			const location = window.location.pathname;
			const path = location.split("/")[1];

			return pageTypes[path] || "page";
		};

		const dataSource = elTarget.getAttribute("data-source") || false;
		if (dataSource === "cart-upsell") return "Basket recommendation";
		if (elTarget && elTarget.closest(".products-recommended")) return "You might also love";

		const pageType = getPageType();
		const pageOrigin = { category: "PLP add to basket", product: "Product PDP", page: "Page add to basket" };
		return pageOrigin[pageType];
	}

	sendCoreEvents(event, payload) {
		try {
			switch (event) {
				case "addedToCart":
					{
						const { target, items } = payload;
						const addType = this.addToCartSource(target);
						const cartItems = window.cart.cartObject?.lines?.nodes || [];
						const addedItemsFiltered = [];

						cartItems.forEach(
							(cartItem) =>
								items.forEach((addedItem) => {
									if (addedItem.merchandiseId === cartItem.merchandise.id) {
										addedItemsFiltered.push({ ...cartItem, quantity: addedItem.quantity });
									}
								}),
							[]
						);

						if (!addedItemsFiltered.length) break;

						addedItemsFiltered.forEach((addedItem) => {
							window.rudderTracker.sendEvent({
								type: "track",
								payload: {
									type: "rudderstack",
									event: "Product Added",
									properties: {
										cart_id: window.cart.cartId,
										currency: "GBP",
										price: parseFloat(addedItem.merchandise.price.amount),
										product_id: addedItem.merchandise.id,
										quantity: addedItem.quantity,
										sku: addedItem.merchandise.sku,
										add_type: addType,
									},
								},
							});

							window.OmetriaAnalytics.sendEvent({
								type: "trackAddToBasket",
								payload: {
									productId: addedItem.merchandise.product.id,
									quantity: addedItem.quantity,
								},
							});
						});

						window.OmetriaAnalytics.sendEvent({ type: "setBasket", payload: window.cart.cartObject });
					}
					break;
				case "removedFromCart": {
					const { cart, removedItems } = payload;
					removedItems.forEach((item) => {
						window.rudderTracker.sendEvent({
							type: "track",
							payload: {
								event: "Item removed",
								properties: {
									product_id: item.merchandise.id,
								},
							},
						});
					});
					window.OmetriaAnalytics.sendEvent({ type: "setBasket", payload: cart });
					break;
				}
				case "fetchCart":
					window.OmetriaAnalytics.sendEvent({ type: "setBasket", payload: window.cart.cartObject });
					break;
				default:
					console.log("Event invalid");
					break;
			}
		} catch (error) {
			console.log(error);
		}
	}

	// Utils

	static getCookie(cname) {
		const decodedCookie = decodeURIComponent(document.cookie);
		const match = decodedCookie.match(new RegExp(`(^| )${cname}=([^;]+)`));
		return match ? match[2] : null;
	}

	// Compare cart against payload and return new items/qty
	cartAddedItems(cart, payloadItems) {
		const lines = cart.lines?.nodes || [];
		const addedQtyMap = payloadItems.reduce((map, item) => {
			map[item.merchandiseId] = item.quantity;
			return map;
		}, {});

		const newItems = lines
			.filter((line) => addedQtyMap[line.merchandise.id])
			.map((line) => ({
				...line,
				quantityAdded: addedQtyMap[line.merchandise.id],
			}));

		return newItems;
	}

	cartRemovedItems(oldCart, payloadLnIds) {
		const lines = oldCart.lines?.nodes || [];
		const removedItems = lines.filter((ln) => payloadLnIds.find((id) => id === ln.id));
		return removedItems;
	}

	// add products to cart from PLP and strapi components
	async addToCart(e, itemGroup) {
		const { currentTarget: target } = e;
		if (target.getAttribute("data-add-collection")) {
			// add a collection of products
			itemGroup = JSON.parse(target.dataset.addToCart).map((item) => ({
				merchandiseId: item.variantId,
				quantity: item.quantity || 1,
			}));
		}

		target.setAttribute("disabled", true);
		const previousBtn = target.innerHTML;
		const btnTitle = target.innerText;

		const items = itemGroup || [
			{ merchandiseId: target.dataset.addToCart, quantity: Number(target.nextElementSibling?.value) || 1 },
		];

		const previousCart = JSON.parse(JSON.stringify(window.cart));
		const response = await this.addItemsCart(e, {
			site: this.siteId,
			...(window.cart.cartId && { cartId: window.cart.cartId }),
			items,
		});

		target.removeAttribute("disabled");
		target.innerHTML = previousBtn;

		this.showMessage(response, previousCart, items);

		this.sendCoreEvents("addedToCart", { items, target });
	}

	showMessage(response, previousCart, items) {
		if (response.lines && Array.isArray(response.lines.nodes)) {
			const messages = [];
			response.lines.nodes.forEach((item) => {
				const previousItem =
					previousCart.cartObject?.lines?.nodes.find(
						(previousCartItem) => previousCartItem.merchandise.id === item.merchandise.id
					) || false;

				const matchingAddedItem = items.find((addedItem) => addedItem.merchandiseId === item.merchandise.id);
				const quantityChange = previousItem ? item.quantity - previousItem.quantity : item.quantity;
				if (matchingAddedItem) {
					if (quantityChange > 0) {
						if (matchingAddedItem.quantity > quantityChange) {
							messages.push(
								`Only ${quantityChange} x ${item.merchandise.product.title} were available, so we've added them to your bag`
							);
						} else {
							messages.push(`${quantityChange} x ${item.merchandise.product.title} added to bag`);
						}
					} else {
						messages.push(`[Sold out] ${item.merchandise.product.title} is <b>sold out</b>`);
					}
				} else if (quantityChange < 0) {
					if (item.quantity === 0) {
						messages.push(
							`[Sold out] ${item.merchandise.product.title} currently in your bag is not available for purchase as it is sold out.`
						);
					} else {
						messages.push(
							`[Sold out] ${quantityChange * -1} of ${
								item.merchandise.product.title
							} has been removed from your bag as it is sold out.`
						);
					}
				}
			});

			messages.sort((x, y) => {
				const isXSoldOut = x.startsWith("[Sold out]");
				const isYSoldOut = y.startsWith("[Sold out]");
				if (isXSoldOut && !isYSoldOut) return 1;
				if (!isXSoldOut && isYSoldOut) return -1;
				return 0;
			});

			this.messages.addMessage(messages);
		}
	}

	handleBtnAddToCart() {
		this.btnAddToCart.forEach((btn) => {
			btn.addEventListener("click", this.addToCart.bind(this));
		});
	}

	static setCookie(cname, cvalue, exdays = 1) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		const expires = `expires=${d.toUTCString()}`;
		document.cookie = `${cname}=${encodeURIComponent(cvalue)};${expires};path=/;SameSite=Lax`;
	}

	static removeCookie(cname) {
		this.setCookie(cname, "", -1);
	}

	static formatCurrency(money, trailingZeros = true) {
		const roundNumberFormatter = new Intl.NumberFormat("en-GB", {
			style: "currency",
			currency: "GBP",
			minimumFractionDigits: trailingZeros ? 2 : 0,
		});

		return roundNumberFormatter.format(money);
	}

	// Cart Methods

	setCartStatus(cart) {
		if (cart) {
			const qty = this.countCartItems(cart);
			window.cart = {
				cartObject: cart,
				cartSize: qty,
				cartId: cart.id,
				subtotal: parseFloat(cart.cost.subtotalAmount.amount),
				total: parseFloat(cart.cost.totalAmount.amount),
			};
			Core.setCookie("patch_cartId", cart.id, 1);
			Core.setCookie("patch_cartQty", qty, 1);
			this.updateCartIcons(qty);
		} else {
			window.cart = {
				cartObject: null,
				cartSize: 0,
				cartId: null,
				subtotal: 0,
				total: 0,
			};
			Core.removeCookie("patch_cartId");
			Core.removeCookie("patch_cartQty");
			this.updateCartIcons(0);
		}
	}

	countCartItems(cart) {
		if (!cart) return 0;
		return cart.lines.nodes.reduce((acc, item) => acc + item.quantity, 0);
	}

	updateCartIcons(quantity) {
		if (quantity > 0) {
			this.cartBagIcons.forEach((cartIcon) => {
				cartIcon.toggleAttribute("hidden", cartIcon.dataset.cartIcon === "empty");
			});
			this.cartQuantityIcon.classList.remove("scale-50");
			this.cartQuantityIcon.addEventListener(
				"transitionend",
				() => {
					this.cartQuantityIcon.classList.add("scale-50");
				},
				{
					once: true,
				}
			);
			this.cartQuantityIcon.innerText = quantity;
		} else {
			this.cartBagIcons.forEach((cartIcon) => {
				cartIcon.toggleAttribute("hidden", cartIcon.dataset.cartIcon === "full");
			});
			this.cartQuantityIcon.innerText = "";
		}
	}

	/**
	 * Async XMLHttpRequest
	 *
	 * @param {Object} request
	 * @param {string} request.url
	 * @param {string} [request.method = 'GET']
	 * @param {Object} [request.headers = {}]
	 * @param {string} request.headers[].key
	 * @param {string} request.headers[].value
	 * @param {string} [request.data = null]
	 *
	 * @returns {Promise}
	 */
	async asyncRequest({ url, method = "GET", headers = {}, data = null }) {
		return new Promise((resolve, reject) => {
			const request = new XMLHttpRequest();
			request.open(method, url);
			Object.entries(headers).forEach(([key, value]) => {
				if (key && value) request.setRequestHeader(key, value);
			});

			request.send(data);
			request.onload = () => resolve(request);
			request.onerror = (error) => reject(error);
		});
	}

	async fetchCart() {
		if (!window.cart.cartId) return this.setCartStatus();

		const url = `${this.apiUrl}/cart/fetch/?cartId=${encodeURIComponent(window.cart.cartId)}&site=${
			this.siteId
		}&v=${new Date().getTime()}`;

		const request = await this.asyncRequest({ url });

		if (!request || request.status !== 200) return this.setCartStatus();

		const { cart } = JSON.parse(request.response);

		this.sendCoreEvents("fetchCart", { cart });

		window.dispatchEvent(new CustomEvent("cart:fetchCart", { detail: { items: cart } }));
		return this.setCartStatus(cart);
	}

	/**
	 * @param {Object} payload
	 * @param {String} payload.site
	 * @param {String} [payload.cartId]
	 * @param {Object[]} payload.items
	 * @param {String} payload.items[].merchandiseId
	 * @param {Number} payload.items[].quantity
	 * @param {Object[]} [payload.items[].attributes]
	 * @param {String} payload.items[].attributes[].key
	 * @param {String} payload.items[].attributes[].value
	 *
	 */
	async addItemsCart({ currentTarget }, payload) {
		const request = await this.asyncRequest({
			url: `${this.apiUrl}/cart/add-items`,
			method: "POST",
			headers: { "Content-Type": "application/json;charset=UTF-8" },
			data: JSON.stringify(payload),
		});

		if (!request || request.status !== 200) {
			throw new Error("Error when adding item to checkout");
		}

		const { cart, userErrors } = JSON.parse(request.response);

		// Errors from api lambda
		if (userErrors.length > 0) {
			this.messages.addMessage([userErrors[0].message], "error");
			if (!cart) return userErrors;
		}

		this.setCartStatus(cart);

		// Send a custom event with new items
		const addedItems = this.cartAddedItems(cart, payload.items);
		const addSource = this.addToCartSource(currentTarget);
		window.dispatchEvent(new CustomEvent("cart:addItems", { detail: { items: addedItems, eventLabel: addSource } }));

		return cart;
	}

	/**
	 * @param {Object} payload
	 * @param {String} payload.site
	 * @param {String} payload.cartId
	 * @param {Object[]} payload.items
	 * @param {String} payload.items[].id - Cart line id
	 * @param {String} payload.items[].merchandiseId
	 * @param {Number} payload.items[].quantity
	 * @param {Object[]} [payload.items[].attributes]
	 * @param {String} payload.items[].attributes[].key
	 * @param {String} payload.items[].attributes[].value
	 * @returns
	 */
	async updateItemsCart(payload) {
		const request = await this.asyncRequest({
			url: `${this.apiUrl}/cart/update-items`,
			method: "POST",
			headers: { "Content-Type": "application/json;charset=UTF-8" },
			data: JSON.stringify(payload),
		});

		if (!request || request.status !== 200) {
			throw new Error("Error updating cart items");
		}

		const { cart, userErrors } = JSON.parse(request.response);

		// Errors from api lambda
		if (userErrors.length > 0) {
			this.messages.addMessage([userErrors[0].message], "error");
			console.log(userErrors);
			return userErrors;
		}

		this.setCartStatus(cart);
		return cart;
	}

	async addDiscountCode(code) {
		const request = await this.asyncRequest({
			url: `${this.apiUrl}/cart/add-discounts`,
			method: "POST",
			headers: { "Content-Type": "application/json;charset=UTF-8" },
			data: JSON.stringify({
				site: this.siteId,
				cartId: window.cart.cartId,
				discountCodes: [code],
			}),
		});

		if (!request || request.status !== 200) {
			throw new Error("Error updating cart items");
		}

		const { cart, userErrors } = JSON.parse(request.response);

		// Errors from api lambda
		if (userErrors.length > 0) {
			this.messages.addMessage([userErrors[0].message], "error");
			console.log(userErrors);
			return userErrors;
		}

		this.setCartStatus(cart);
		return cart;
	}

	/**
	 * @param {Object} payload
	 * @param {String} payload.site
	 * @param {String} payload.cartId
	 * @param {String[]} payload.lineItemIds
	 * @returns
	 */
	async removeItemsCart(payload) {
		const request = await this.asyncRequest({
			url: `${this.apiUrl}/cart/remove-items`,
			method: "POST",
			headers: { "Content-Type": "application/json;charset=UTF-8" },
			data: JSON.stringify(payload),
		});

		if (!request || request.status !== 200) {
			throw new Error("Error removing cart items");
		}

		const { cart, userErrors } = JSON.parse(request.response);

		// Errors from api lambda
		if (userErrors.length > 0) {
			this.messages.addMessage([userErrors[0].message], "error");
			console.log(userErrors);
			return userErrors;
		}

		try {
			// filter only items removed
			const removedItems = window.cart.cartObject.lines.nodes.filter((ln) =>
				payload.lineItemIds.find((id) => id === ln.id)
			);
			this.sendCoreEvents("removedFromCart", { cart, removedItems });
		} catch (error) {
			// do nothing
		}

		// keep copy of old cart before call setCartStatus
		const oldCart = structuredClone(window.cart?.cartObject || {});

		this.setCartStatus(cart);

		// Send a custom event with new items
		const removedItems = this.cartRemovedItems(oldCart, payload.lineItemIds);
		window.dispatchEvent(new CustomEvent("cart:removeItems", { detail: { items: removedItems } }));

		return cart;
	}

	// Others

	async initCarousels() {
		const carouselEles = document.querySelectorAll("[data-carousel]");
		if (!carouselEles) return;

		let v = "";
		try {
			const { currentScript } = document;
			const urlParams = new URL(currentScript.src).searchParams;
			v = urlParams.get("v");
		} catch (e) {
			// nothing
		}

		// EXPERIMENT: plp-image-carousel
		const carouselScript = document.createElement("script");
		carouselScript.src = `/assets/js/variant_1_carousel.js?v=${v}`;
		document.body.appendChild(carouselScript);

		const result = await new Promise((resolve, reject) => {
			carouselScript.addEventListener("load", resolve);
			carouselScript.addEventListener("error", (error) => reject(error));
		});
		if (result.type !== "load") return;
		carouselEles.forEach((ele) => {
			const { autoAdvance, playOnce, loop } = ele.dataset;
			// eslint-disable-next-line no-new
			new Carousel(ele, { autoAdvance, playOnce, loop });
		});
	}

	handleStickyOnScroll() {
		const stickyOnScrollEles = Array.from(document.querySelectorAll("[data-sticky-scroll]"));
		window.lastScrollY = window.scrollY;
		window.prevScrollUp = false;
		window.addEventListener("scroll", () => {
			const scrollUp = window.scrollY < window.lastScrollY;
			window.lastScrollY = window.scrollY;
			stickyOnScrollEles.forEach((ele) => {
				const isMobileScreen = window.matchMedia("(max-width: 767px)").matches;

				const isInViewport = () => {
					const { top, bottom, height } = ele.getBoundingClientRect();
					const html = document.documentElement;
					return top + height >= 0 && bottom <= (window.innerHeight || html.clientHeight);
				};

				if (scrollUp && isMobileScreen && !window.prevScrollUp && !isInViewport()) {
					ele.animate([{ transform: "scaleY(0)" }, { transform: "scaleY(1)" }], {
						duration: 500,
						iterations: 1,
						fill: "forwards",
					});
				}

				const { stickyScroll } = ele.dataset;
				if (!stickyScroll) {
					ele.style.setProperty("--stickyTop", `${scrollUp ? 0 : ele.clientHeight * -1}px`);
					return;
				}

				const stickyElement = document.getElementById(stickyScroll);

				if (!stickyElement) return;
				ele.style.setProperty("--stickyTop", `${scrollUp ? stickyElement.clientHeight : ele.clientHeight * -1}px`);
			});
			window.prevScrollUp = scrollUp;
		});
	}

	handleToggles() {
		const toggles = document.querySelectorAll("[data-toggle]");
		toggles.forEach((toggle) => {
			toggle.addEventListener("click", () => {
				const isExpanded = toggle.getAttribute("aria-expanded") === "true";
				toggle.setAttribute("aria-expanded", `${!isExpanded}`);
			});
		});
	}

	handleIntersections() {
		function cbDataOnIntersect(entries, observer) {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				const { target } = entry;
				const intersectionClasses = target.dataset.onIntersect;
				target.classList.add(intersectionClasses);
				observer.unobserve(target);
			});
		}
		function cbLazyLoadOnIntersect(entries, observer) {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				const { target } = entry;
				const { backgroundImage, backgroundImageMobile } = target.dataset;
				if (backgroundImageMobile && window.innerWidth < 640) {
					target.style.backgroundImage = `url('${backgroundImageMobile}')`;
				} else {
					target.style.backgroundImage = `url('${backgroundImage}')`;
				}
				observer.unobserve(target);
			});
		}

		if ("IntersectionObserver" in window) {
			// Adds opacity:100 on opaque sections
			const dataOnIntersectObserver = document.querySelectorAll("[data-on-intersect]");
			const doiObserver = new IntersectionObserver(cbDataOnIntersect, { threshold: 0.25 });
			dataOnIntersectObserver.forEach((node) => doiObserver.observe(node));

			// lazy load background images
			const lazyLoadBackgroundImageObserver = document.querySelectorAll("[data-background-image]");
			lazyLoadBackgroundImageObserver.forEach((node) => {
				node.style.backgroundColor = "#f9f7f0";
			});
			const lbiObserver = new IntersectionObserver(cbLazyLoadOnIntersect, { rootMargin: "100px" });
			lazyLoadBackgroundImageObserver.forEach((node) => lbiObserver.observe(node));
		} else {
			const dataOnIntersectObserver = document.querySelectorAll("[data-on-intersect]");
			dataOnIntersectObserver.forEach((node) => {
				const intersectionClasses = node.dataset.onIntersect;
				node.classList.add(intersectionClasses);
			});

			const lazyLoadBackgroundImageObserver = document.querySelectorAll("[data-background-image]");
			lazyLoadBackgroundImageObserver.forEach((node) => {
				const { backGroundImage } = node.dataset;
				node.style.backgroundImage = `url('${backGroundImage}')`;
			});
		}
	}

	clearModal() {
		if (!this.modalContainer) return;
		this.modalContainer.innerHTML = "";
	}

	addModal(templateIdOrChild, closeFunction = null) {
		if (!this.modalContainer) return null;

		let modalNode = templateIdOrChild;

		if (typeof templateIdOrChild === "string") {
			const modalTemplate = document.getElementById(templateIdOrChild);
			if (!modalTemplate) return null;
			modalNode = modalTemplate.content.cloneNode(true);
		}

		this.clearModal();
		this.modalContainer.appendChild(modalNode);

		this.modalContainer.querySelectorAll("[data-close-modal]").forEach((btn) => {
			btn.addEventListener("click", (e) => {
				this.clearModal();
				document.body.classList.remove("overflow-hidden");
				if (closeFunction) closeFunction(e);
			});
		});
		document.body.classList.add("overflow-hidden");
		return this.modalContainer.firstElementChild;
	}

	setupToggle() {
		const containers = document.querySelectorAll(".container-disclosure");

		containers.forEach((container) => {
			const clickable = container.querySelector(".clickable");
			const content = container.querySelector(".content");
			const chevronUp = container.querySelector(".chevronUp");
			const chevronDown = container.querySelector(".chevronDown");
			const title = container.querySelector(".title");

			content.classList.add("hidden");
			chevronUp.classList.add("hidden");
			chevronDown.classList.remove("hidden");

			clickable.addEventListener("click", () => {
				const isHidden = content.classList.contains("hidden");

				if (isHidden) {
					content.classList.remove("hidden");
					chevronDown.classList.add("hidden");
					chevronUp.classList.remove("hidden");
					title.classList.add("underline", "decoration-1", "decoration-secondary-900");
				} else {
					content.classList.add("hidden");
					chevronDown.classList.remove("hidden");
					chevronUp.classList.add("hidden");
					title.classList.remove("underline", "decoration-1", "decoration-secondary-900");
				}
			});
		});
	}

	handleCallouts() {
		const calloutsWrapper = document.getElementById("callouts");
		if (!calloutsWrapper) return;

		const primaryNav = document.getElementById("desktop-primary-navigation");
		const callouts = Array.from(calloutsWrapper.querySelectorAll("li"));

		const { bottom } = calloutsWrapper.getBoundingClientRect();
		primaryNav.style.setProperty("--calloutHeight", bottom > 0 ? `${bottom}px` : "0px");

		setInterval(() => {
			for (let i = 0; i < callouts.length; i += 1) {
				if (!callouts[i].classList.contains("hidden")) {
					callouts[i].classList.add("hidden");
					if (i + 1 < callouts.length) {
						callouts[i + 1].classList.remove("hidden");
					} else {
						callouts[0].classList.remove("hidden");
					}
					break;
				}
			}
		}, 5000);

		window.addEventListener("scroll", () => {
			const { bottom: calloutH } = calloutsWrapper.getBoundingClientRect();
			primaryNav.style.setProperty("--calloutHeight", calloutH > 0 ? `${calloutH}px` : "0px");
		});
	}

	async init() {
		await this.fetchCart();
		await this.initCarousels();
		this.handleStickyOnScroll();
		this.handleToggles();
		this.updateCartIcons(window.cart.cartSize);
		this.handleBtnAddToCart();
		this.setupToggle();
		this.handleCallouts();
	}
}

// eslint-disable-next-line no-new
const core = new Core();
core.init();
document.addEventListener("DOMContentLoaded", core.handleIntersections(), { once: true });
